/* import __COLOCATED_TEMPLATE__ from './descriptions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();